(() => {
  const getWarsawParts = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Warsaw',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());

    return Object.fromEntries(parts.map((part) => [part.type, part.value]));
  };

  const getDispatchMessage = () => {
    const parts = getWarsawParts();
    const weekday = parts.weekday;
    const hour = Number(parts.hour);
    const minute = Number(parts.minute);
    const second = Number(parts.second);
    const businessDay = !['Sat', 'Sun'].includes(weekday);

    if (businessDay && hour < 10) {
      const remaining = (10 * 3600) - (hour * 3600 + minute * 60 + second);
      const h = String(Math.floor(remaining / 3600)).padStart(2, '0');
      const m = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
      const s = String(remaining % 60).padStart(2, '0');
      return {
        lead: 'Wyślemy jeszcze dzisiaj',
        prefix: 'Zamów w ciągu ',
        emphasis: `${h}:${m}:${s}`
      };
    }

    return {
      lead: 'Wysyłka w ciągu 24h',
      prefix: 'Produkt jest dostępny i gotowy do szybkiej realizacji',
      emphasis: ''
    };
  };

  class DecoRatonDispatchPromise extends HTMLElement {
    connectedCallback() {
      this.update();
      this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
    }

    update() {
      const message = getDispatchMessage();
      const lead = document.createElement('span');
      lead.className = 'dr-dispatch-promise__lead';
      lead.textContent = message.lead;

      const detail = document.createElement('span');
      detail.className = 'dr-dispatch-promise__detail';
      detail.append(document.createTextNode(message.prefix));

      if (message.emphasis) {
        const emphasis = document.createElement('strong');
        emphasis.className = 'dr-dispatch-promise__emphasis';
        emphasis.textContent = message.emphasis;
        detail.append(emphasis);
      }

      this.replaceChildren(lead, detail);
    }
  }

  class DecoRatonQuantityPresets extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      const input = document.getElementById(this.dataset.inputId);
      if (!input) return;

      const buttons = Array.from(this.querySelectorAll('[data-quantity]'));
      const sync = () => {
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Infinity;
        const current = Number(input.value || min);

        buttons.forEach((button) => {
          const qty = Number(button.dataset.quantity);
          button.hidden = qty < min || qty > max;
          button.classList.toggle('is-active', qty === current);
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const qty = Number(button.dataset.quantity);
          const min = Number(input.min || 1);
          const max = input.max ? Number(input.max) : Infinity;
          const next = Math.min(Math.max(qty, min), max);
          input.value = next;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        });
      });

      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      sync();
    }
  }

  class DecoRatonStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.mainButton = document.querySelector('product-info .product-form__submit');
      this.mainPrice = document.querySelector('product-info [id^="price-"] .price');
      this.stickyButton = this.querySelector('[data-sticky-submit]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');
      this.footerVisible = false;

      if (!this.mainButton || !this.stickyButton) return;

      const sync = () => {
        this.stickyButton.disabled = this.mainButton.disabled;
        const sourceText = this.mainButton.querySelector('span')?.textContent?.trim();
        if (sourceText) this.stickyButton.textContent = sourceText;

        if (this.mainPrice && this.stickyPrice) {
          const onSale = this.mainPrice.classList.contains('price--on-sale');
          const priceNode = onSale
            ? this.mainPrice.querySelector('.price__sale .price-item--last')
            : this.mainPrice.querySelector('.price__regular .price-item--regular');
          if (priceNode) this.stickyPrice.textContent = priceNode.textContent.trim();
        }
      };

      const updateVisibility = () => {
        const rect = this.mainButton.getBoundingClientRect();
        const passedMainButton = rect.bottom < 0;
        this.classList.toggle('is-visible', passedMainButton && !this.footerVisible);
      };

      this.stickyButton.addEventListener('click', () => {
        if (!this.mainButton.disabled) this.mainButton.click();
      });

      new MutationObserver(sync).observe(this.mainButton, {
        attributes: true,
        childList: true,
        subtree: true
      });

      if (this.mainPrice) {
        new MutationObserver(sync).observe(this.mainPrice, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      const footer = document.querySelector('.footer');
      if (footer) {
        new IntersectionObserver((entries) => {
          this.footerVisible = entries[0]?.isIntersecting || false;
          updateVisibility();
        }, { threshold: 0.01 }).observe(footer);
      }

      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      sync();
      updateVisibility();
    }
  }

  if (!customElements.get('decoraton-dispatch-promise')) {
    customElements.define('decoraton-dispatch-promise', DecoRatonDispatchPromise);
  }
  if (!customElements.get('decoraton-quantity-presets')) {
    customElements.define('decoraton-quantity-presets', DecoRatonQuantityPresets);
  }
  if (!customElements.get('decoraton-sticky-atc')) {
    customElements.define('decoraton-sticky-atc', DecoRatonStickyAtc);
  }
})();